import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/index.css';
import { AuthProvider } from "./context/AuthContext";
import { SharedListProvider } from "./context/SharedListContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <SharedListProvider>
        <App />
      </SharedListProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals(console.log);
